import React from "react";

import { Text } from "@performyard/py-components";

import Spacer from "../../../../components/Spacer";
import EmptyWorkspace from "./EmptyWorkspace";

interface WorkspaceDetailsEmptyStateProps {
	hasFiltersApplied: boolean;
	isAdmin?: boolean;
}

const WorkspaceDetailsEmptyState = ({ hasFiltersApplied, isAdmin = false }: WorkspaceDetailsEmptyStateProps) => {
	const message = hasFiltersApplied
		? "No meetings match the applied filters."
		: isAdmin
			? "This workspace is empty."
			: "This workspace is empty, please add a meeting.";

	return (
		<div className="flex h-[calc(100vh-408px)] flex-col items-center justify-center">
			<EmptyWorkspace />
			<Spacer height={2} />
			<Text size="paragraph-1" weight="semi-bold">
				{message}
			</Text>
		</div>
	);
};

export default WorkspaceDetailsEmptyState;
